const LoginPage = ({
  email,
  password,
  error,
  loading,
  onEmailChange,
  onPasswordChange,
  onSignup,
  onLogin
}) => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#030712",
        fontFamily: "Arial"
      }}
    >
      <div
        style={{
          width: "380px",
          padding: "32px",
          borderRadius: "16px",
          background: "rgba(15,23,42,0.9)",
          border: "1px solid rgba(255,255,255,0.1)",
          color: "white"
        }}
      >
        <h1 style={{ textAlign: "center", marginBottom: "24px" }}>
          Login
        </h1>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          style={{
            width: "100%",
            padding: "12px",
            marginBottom: "12px",
            borderRadius: "8px",
            border: "none"
          }}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onLogin()}
          style={{
            width: "100%",
            padding: "12px",
            marginBottom: "12px",
            borderRadius: "8px",
            border: "none"
          }}
        />

        <button
          onClick={onLogin}
          style={{
            width: "100%",
            padding: "12px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            background: "#4f46e5",
            color: "white"
          }}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <button
          onClick={onSignup}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "12px",
            borderRadius: "12px",
            background: "transparent",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "white",
            cursor: "pointer"
          }}
        >
          Create account
        </button>

        {error && (
          <p style={{ color: "red", marginTop: "12px", textAlign: "center" }}>
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoginPage;